( function () {
	'use strict';

	function ForgotPasswordService ( logger,  $http ) {
		/**
		 * checks if email is a valid registered emaill address and sends a notification if not then throws a error
		 * https://dev.pd360.com/com/schoolimprovement/pd360/dao/EmailService.cfc?method=sendPasswordEmail&returnformat=json&emailTo={email
		 */

		function forgotPassword ( email ) {
			return $http( {
				'method' : 'GET',
				'url'    : 'https://dev.pd360.com/com/schoolimprovement/pd360/dao/EmailService.cfc?method=sendPasswordEmail&returnformat=json&emailTo=' + email
			} );
		}

		return {
			'forgotPassword' : forgotPassword
		};
	}

	angular
		.module( 'app.forgot-password' )
		.factory( 'ForgotPasswordService', ForgotPasswordService );

	ForgotPasswordService.$inject = [ 'logger', '$http' ];
} )( );
